import { render, staticRenderFns } from "./SessionPresentationCount.vue?vue&type=template&id=78408c31"
import script from "./SessionPresentationCount.vue?vue&type=script&lang=ts"
export * from "./SessionPresentationCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports